
$(document).ready(function() {

    if ($('table.profiles-table')) {
      setupFilterButtons();
    }

    function setupFilterButtons () {

      $('.custom-select-radios.filter ul li label input').on('change', function(e) {

        var dataName = $(this).prop('name');

        var checkedVal = $(this).val();

        hideShowRows(dataName, checkedVal);

      });
    }

    function hideShowRows(dataName, checkedVal) {

      $('.profiles-table tbody tr').each(function (i) {
        if ($(this).hasClass('showMe')) {
          $(this).removeClass('showMe')
        }
        if ($(this).data(dataName) != checkedVal) {
          $(this).addClass('d-none');
        }

        if ($(this).data(dataName) == checkedVal) {
          $(this).addClass('showMe fade-out');
          if ($(this).hasClass('d-none')) {
            $(this).removeClass('d-none')
          }
        }
      });

      var count = 0;
      var $reStripeThese = $('tr.card.showMe');

      $reStripeThese.each(function(i) {
        if ((count % 2) != 0) {
            $(this).removeClass('even');
            $(this).addClass('odd');
            count++;
        } else {
            $(this).removeClass('odd');
            $(this).addClass('even');
            count++;
        }
        var _this = $(this);
        setTimeout(function() {
          _this.removeClass('fade-out');
        }, 50*count);
      });
      console.log(count);
    }

    //
    var itemsPerPage = $('.custom-select-radios.pages input:checked').val();

    var visibleItems = $('tr.card:visible').length;

    if (visibleItems < itemsPerPage) {
      $('.custom-select-radios.pages').hide();
      $('.pagination').parent().hide();
    }

    ///// Pointless Cloning, needs dynamic call /////
    // $('tr.card.new-row').each(function() {
    //   $(this).remove();
    // });
    //cloneItems(visibleItems, checkedVal, dataName, perPage);
    ///////////////////////////

    ////// Remove this function for prod - need AJAX-ifying if there are more items ///////
    // function cloneItems(visibleItems, val, dataName, perPage) {
    //
    //   var itemsToClone = perPage - visibleItems;
    //
    //   for(i=0; i < itemsToClone; i++) {
    //
    //      var clone = $('tr[data-'+dataName+'="'+val+'"]:first').clone();
    //
    //      clone.appendTo('.profiles-table tbody')
    //      clone.css('display', 'none');
    //      clone.addClass('new-row');
    //      clone.attr('style', '');
    //   }
    //
    // }
    ///////////////////////////////////////////////

  });
